import React from "react";
import ListItem from "@mui/material/ListItem";
import Avatar from "@mui/material/Avatar";
import { ListItemText } from "@mui/material";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import MoreIcon from "@mui/icons-material/MoreVert";
import * as PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  member: {
    marginLeft: "10px",
  },
  roleName: {
    fontStyle: "italic",
    color: theme.palette.grey[600],
  },
  reject: {
    color: theme.palette.error.main,
  },
}));

HomeMember.propTypes = {
  member: PropTypes.shape({
    username: PropTypes.string,
    img: PropTypes.string,
    role: PropTypes.shape({ name: PropTypes.string }),
  }).isRequired,
  onMemberClicked: PropTypes.func,
};

HomeMember.defaultProps = {
  onMemberClicked: null,
};

export default function HomeMember(props: any) {
  const { classes } = useStyles();
  return (
    <ListItem>
      <Avatar
        alt={props.member.username.toLocaleUpperCase()}
        src={props.member.img || "#"}
      />
      <ListItemText className={classes.member}>
        <span>{props.member.username}</span>&nbsp;
        <span className={classes.roleName}>({props.member.role.name})</span>
      </ListItemText>
      {props.onMemberClicked && (
        <ListItemSecondaryAction>
          <IconButton
            className={classes.reject}
            onClick={(e: any) => props.onMemberClicked(e, props.member)}
            aria-label="reject-invite"
          >
            <MoreIcon />
          </IconButton>
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
}
